import styled from 'styled-components';

export default styled.hr`
	margin: var(--px-12) 0;
	height: var(--px-1);
	min-height: var(--px-1);
	background-color: var(--neutrals-200);
	border: none;
`;
